import { useState, useEffect } from 'react';
import './bread-crumb-lists.scss';
import { getLangSite } from "../../ultils/translation.util";

import { getListNameById } from '../../services';

interface IProps {
    listId: string;
    customerId: number;
}

const BreadcrumbLists: React.FC<IProps> = ({ listId, customerId }) => {
    const langSiteObj = getLangSite('en');
    const lang = langSiteObj.lang;

    const [listDetail, setListDetail] = useState<any>({});

    useEffect(() => {
        const getListObject = async () => {
            if (listId && customerId) {
                const responseObject = await getListNameById(customerId, listId);
                setListDetail(responseObject);
            }
        };
        getListObject();
    }, [customerId, listId]);

    return (
        <div id="dashboard-breadcrumbs" className="w-full pt-2">
            <nav aria-label="Breadcrumb" className="dk-breadcrumb">
                <ol>
                    <li>
                        <a href="/mydigikey">Dashboard</a>
                    </li>
                    <li>
                        <a href={`/${lang}/mylists/`}>Lists</a>
                    </li>
                    <li>
                        <a href={`/${lang}/mylists/list/${listId}`}>{listDetail?.listName}</a>
                    </li>
                </ol>
            </nav>
        </div>
    )
}

export default BreadcrumbLists;